var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.188 464H124.812L90.537 224H42.033L80.234 491.406C81.938 503.219 92.062 512 104 512H344C355.938 512 366.062 503.219 367.766 491.406L405.967 224H357.463L323.188 464ZM424 144H128V136C128 101.172 152.877 72.055 185.797 65.438C193.135 74.148 203.719 80 216 80H296C318.092 80 336 62.09 336 40C336 17.906 318.092 0 296 0H216C202.377 0 190.939 7.246 183.715 17.648C125.293 25.688 80 75.422 80 136V144H24C10.75 144 0 154.75 0 168S10.75 192 24 192H424C437.25 192 448 181.25 448 168S437.25 144 424 144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.ce915b89033e69c2f28911d8ff549046.svg";
export { ForwardRef as ReactComponent };